(() => {
  const els = {};
  const state = { product: null, selected: {}, open: false };

  const moneyMx = (cents) => `$${(cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MXN`;

  const fetchProduct = async (handle) => {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error(`Product fetch failed: ${res.status}`);
    return res.json();
  };

  const isColorOption = (name) => /color|colour|tono|tono de/i.test(name);
  const optName = (opt) => typeof opt === 'string' ? opt : (opt && (opt.name || opt.title)) || '';
  const optNames = (product) => (product.options || []).map(optName);

  // Si el título empieza con el vendor (case-insensitive), quitarlo del display
  const stripVendorFromTitle = (title, vendor) => {
    if (!title || !vendor) return title || '';
    const t = String(title);
    const v = String(vendor);
    if (t.toLowerCase().startsWith(v.toLowerCase())) {
      let rest = t.slice(v.length).trim();
      // Quitar separador inicial común
      if (rest && /^[—·\-+|]/.test(rest)) {
        rest = rest.slice(1).trim();
      }
      return rest || t;
    }
    return t;
  };

  const PALETTE = ['#E63E5C', '#C9A85C', '#6E3C8B', '#B82746', '#E89181', '#3E1F50', '#FF6B9D', '#8B4513', '#FF8FA3', '#1A0710'];

  const hashString = (str) => {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = ((h << 5) - h + str.charCodeAt(i)) | 0;
    return Math.abs(h);
  };

  const colorFromValue = (value, productId) => {
    const clean = (value || '').toLowerCase().replace(/\s/g, '');
    if (/^#?[0-9a-f]{6}$/.test(clean)) return clean.startsWith('#') ? clean : `#${clean}`;
    if (/^#?[0-9a-f]{3}$/.test(clean)) return clean.startsWith('#') ? clean : `#${clean}`;
    const namedMap = {
      'negro': '#1A0710', 'blanco': '#F4EDE4', 'rosa': '#FF8FA3', 'rojo': '#E63E5C',
      'beige': '#E5D2A0', 'nude': '#E5D2A0', 'bronce': '#8B4513', 'bronze': '#8B4513',
      'dorado': '#C9A85C', 'plata': '#C0C0C0', 'morado': '#6E3C8B', 'violeta': '#6E3C8B',
      'fucsia': '#E63E5C', 'coral': '#E89181', 'durazno': '#FF8FA3', 'cafe': '#8B4513',
      'glitter': '#C9A85C', 'glossy': '#FF8FA3', 'holographic': '#6E3C8B',
    };
    if (namedMap[clean]) return namedMap[clean];
    const offset = (productId || 0) % PALETTE.length;
    const idx = (hashString(clean) + offset) % PALETTE.length;
    return PALETTE[idx];
  };

  const findVariant = () => {
    if (!state.product) return null;
    const names = optNames(state.product);
    return state.product.variants.find((v) =>
      names.every((name, i) => v.options[i] === state.selected[name])
    );
  };

  const render = (product, handle) => {
    state.product = product;
    state.selected = {};
    const names = optNames(product);
    names.forEach((name, i) => {
      const firstAvailable = product.variants.find((v) => v.available) || product.variants[0];
      state.selected[name] = firstAvailable.options[i];
    });

    els.title.textContent = stripVendorFromTitle(product.title, product.vendor);
    els.short.textContent = (product.description || '').replace(/<[^>]+>/g, ' ').slice(0, 180) + (product.description && product.description.length > 180 ? '…' : '');
    els.brand.textContent = product.vendor || '';
    els.brand.style.display = product.vendor ? '' : 'none';
    els.more.href = product.url || `/products/${handle}`;
    els.form.dataset.handle = handle;

    // Media
    els.imgs.innerHTML = '';
    els.thumbs.innerHTML = '';
    const fallbacks = window.cherryFallbackImages || [];
    const fallbackUrl = fallbacks[(product.id || 0) % (fallbacks.length || 1)] || '';

    let mediaItems = (product.media && product.media.length > 0)
      ? product.media.map((m) => m.preview_image || m)
      : (product.featured_image ? [{ src: product.featured_image }] : []);

    if (mediaItems.length === 0 && fallbackUrl) {
      mediaItems = [{ src: fallbackUrl }];
    }

    mediaItems.forEach((m, i) => {
      const img = document.createElement('img');
      img.src = m.src;
      img.alt = product.title;
      img.addEventListener('error', () => {
        if (fallbackUrl && img.src !== fallbackUrl) img.src = fallbackUrl;
      });
      if (i === 0) img.classList.add('is-active');
      els.imgs.appendChild(img);

      if (mediaItems.length > 1) {
        const thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'cherry-qv__media-thumb' + (i === 0 ? ' is-active' : '');
        thumb.innerHTML = `<img src="${m.src}" alt="">`;
        thumb.addEventListener('click', () => {
          els.thumbs.querySelectorAll('button').forEach((b) => b.classList.remove('is-active'));
          thumb.classList.add('is-active');
          els.imgs.querySelectorAll('img').forEach((im, j) => im.classList.toggle('is-active', j === i));
        });
        els.thumbs.appendChild(thumb);
      }
    });

    // Options
    els.options.innerHTML = '';
    const optionNames = optNames(product);
    if (!product.has_only_default_variant && optionNames.length > 0) {
      optionNames.forEach((optionName, optIdx) => {
        const wrap = document.createElement('div');
        wrap.className = 'cherry-qv__option';
        const label = document.createElement('div');
        label.className = 'cherry-qv__option-label';
        label.innerHTML = `<span>${optionName}</span> <small data-selected>${state.selected[optionName]}</small>`;
        wrap.appendChild(label);

        const isColor = isColorOption(optionName);
        const group = document.createElement('div');
        group.className = isColor ? 'cherry-qv__swatches' : 'cherry-qv__pills';

        const values = [...new Set(product.variants.map((v) => v.options[optIdx]))];
        values.forEach((value) => {
          const variantWithValue = product.variants.find((v) => v.options[optIdx] === value);
          const isActive = state.selected[optionName] === value;
          const isUnavailable = !variantWithValue || !variantWithValue.available;
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.dataset.value = value;
          btn.dataset.optionName = optionName;
          btn.className = (isColor ? 'cherry-qv__swatch' : 'cherry-qv__pill') +
            (isActive ? ' is-active' : '') +
            (isUnavailable ? ' is-unavailable' : '');
          if (isColor) {
            btn.style.backgroundColor = colorFromValue(value, product.id);
            btn.title = value;
            btn.setAttribute('aria-label', value);
          } else {
            btn.textContent = value;
          }
          btn.addEventListener('click', () => {
            state.selected[optionName] = value;
            group.querySelectorAll('button').forEach((b) => b.classList.remove('is-active'));
            btn.classList.add('is-active');
            label.querySelector('[data-selected]').textContent = value;
            updateVariant();
          });
          group.appendChild(btn);
        });
        wrap.appendChild(group);
        els.options.appendChild(wrap);
      });
    }

    updateVariant();
    els.drawer.dataset.state = 'ready';
  };

  const updateVariant = () => {
    const match = findVariant();
    if (!match) return;
    els.variantId.value = match.id;
    els.price.textContent = moneyMx(match.price);
    if (match.compare_at_price && match.compare_at_price > match.price) {
      els.compare.textContent = moneyMx(match.compare_at_price);
      els.compare.hidden = false;
      const discount = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
      els.discount.textContent = `-${discount}%`;
      els.discount.hidden = false;
      els.badge.textContent = `-${discount}%`;
      els.badge.hidden = false;
    } else {
      els.compare.hidden = true;
      els.discount.hidden = true;
      els.badge.hidden = true;
    }
    els.atc.disabled = !match.available;
    els.atcLabel.textContent = match.available ? 'Agregar al carrito' : 'Agotado';
  };

  const open = async (handle) => {
    state.open = true;
    els.drawer.classList.add('is-open');
    els.drawer.setAttribute('aria-hidden', 'false');
    els.overlay.classList.add('is-open');
    els.overlay.setAttribute('aria-hidden', 'false');
    els.drawer.dataset.state = 'loading';
    document.documentElement.style.overflow = 'hidden';
    try {
      const product = await fetchProduct(handle);
      render(product, handle);
      // tracking
      if (window.cherry && window.cherry.track) {
        window.cherry.track('view_quickview', {
          content_ids: [String(product.id)],
          content_name: product.title,
          contents: [{ id: String(product.id), name: product.title, price: (product.price || 0) / 100, quantity: 1 }],
          value: (product.price || 0) / 100,
        });
      }
    } catch (err) {
      console.error(err);
      els.drawer.dataset.state = 'error';
    }
  };

  const close = () => {
    state.open = false;
    els.drawer.classList.remove('is-open');
    els.drawer.setAttribute('aria-hidden', 'true');
    els.overlay.classList.remove('is-open');
    els.overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  };

  const interceptForm = () => {
    els.form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(els.form);
      els.atc.disabled = true;
      els.atcLabel.textContent = 'Sumando…';
      try {
        await fetch('/cart/add.js', { method: 'POST', body: fd });
        close();
        document.dispatchEvent(new CustomEvent('cherry:cart-add'));
        // Abrir carrito drawer
        const cartLink = document.querySelector('#cherry-cart-link');
        if (cartLink) cartLink.click();
      } catch (err) {
        console.error(err);
        els.atcLabel.textContent = 'Reintentar';
        els.atc.disabled = false;
      }
    });
  };

  const init = () => {
    els.drawer = document.querySelector('[data-cherry-qv]');
    els.overlay = document.querySelector('[data-cherry-qv-overlay]');
    if (!els.drawer || !els.overlay) return;

    els.title = els.drawer.querySelector('[data-cherry-qv-title]');
    els.brand = els.drawer.querySelector('[data-cherry-qv-brand]');
    els.short = els.drawer.querySelector('[data-cherry-qv-short]');
    els.price = els.drawer.querySelector('[data-cherry-qv-price]');
    els.compare = els.drawer.querySelector('[data-cherry-qv-compare]');
    els.discount = els.drawer.querySelector('[data-cherry-qv-discount]');
    els.badge = els.drawer.querySelector('[data-cherry-qv-badge]');
    els.imgs = els.drawer.querySelector('[data-cherry-qv-imgs]');
    els.thumbs = els.drawer.querySelector('[data-cherry-qv-thumbs]');
    els.options = els.drawer.querySelector('[data-cherry-qv-options]');
    els.qtyInput = els.drawer.querySelector('[data-cherry-qv-qty]');
    els.atc = els.drawer.querySelector('[data-cherry-qv-atc]');
    els.atcLabel = els.drawer.querySelector('[data-cherry-qv-atc-label]');
    els.more = els.drawer.querySelector('[data-cherry-qv-more]');
    els.variantId = els.drawer.querySelector('[data-cherry-qv-variant-id]');
    els.form = els.drawer.querySelector('[data-cherry-qv-form]');

    document.querySelectorAll('[data-cherry-qv-close]').forEach((b) => b.addEventListener('click', close));
    els.overlay.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && state.open) close();
    });

    els.drawer.querySelector('[data-cherry-qv-qty-down]').addEventListener('click', () => {
      els.qtyInput.value = Math.max(1, parseInt(els.qtyInput.value || 1) - 1);
    });
    els.drawer.querySelector('[data-cherry-qv-qty-up]').addEventListener('click', () => {
      els.qtyInput.value = parseInt(els.qtyInput.value || 1) + 1;
    });

    interceptForm();

    // Trigger from any [data-cherry-quickview] button
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-cherry-quickview]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      const handle = trigger.dataset.cherryQuickview;
      if (handle) open(handle);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
